// extracted by mini-css-extract-plugin
export default {"canvas":"Canvas_canvas__zbANR","circle":"Canvas_circle__tG1rO"};